export default __webpack_public_path__ + "static/media/Offline-online.098079e4.svg";